import { ReactComponent as SvgExternal } from 'public/assets/icons/externallink.svg';

interface IViewTabProps {
  title: string
  className: string
  url?: string
  onClick: () => void
}

const ViewTab = ({
  title, className, url, onClick,
}: IViewTabProps) => {
  const isExternal = !!url && url.startsWith('http');
  if (url) {
    return (
      <a
        href={url}
        target={isExternal ? '_blank' : undefined}
        rel="nofollow noreferrer"
        className={className}
        onClick={onClick}
      >
        {title}
        {isExternal && <SvgExternal />}
      </a>
    );
  }

  return (
    <button
      type="button"
      className={className}
      onClick={onClick}
    >
      {title}
    </button>
  );
};

export default ViewTab;
